/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEaseOutRegular: {
  name: 'ease-out-regular';
  data: string;
} = {
  name: 'ease-out-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.22 3.044c-.833.086-1.932.393-2.78.775C13.103 5.322 9.603 8.881 6.092 14.34c-1.22 1.897-2.949 4.979-3.058 5.451-.169.733.557 1.391 1.272 1.154.323-.108.454-.249.733-.792 2.455-4.767 5.674-9.299 8.397-11.822 2.285-2.116 4.333-3.203 6.247-3.314.589-.034.792-.098 1.013-.32C20.88 4.514 21 4.238 21 4c0-.237-.12-.514-.303-.697-.291-.291-.618-.348-1.477-.259"/></svg>`
};
